import { toast } from "sonner";
import { X } from "lucide-react";
import CartToastFrame from "./CartToastFrame";

type CartMessageToastProps = {
  message: string;
  toastId: string | number;
};

export default function CartMessageToast({
  message,
  toastId,
}: CartMessageToastProps) {
  return (
    <CartToastFrame
      desktopContent={message}
      icon={<X className="size-4 shrink-0 text-[#1f2022]" />}
      onClick={() => toast.dismiss(toastId)}
      ariaLabel={`Dismiss notice: ${message}`}
    />
  );
}
